import styles from './InventoryItem.module.sass';
import cn from "classnames";
import Image from "next/image";
const InventoryItem = ({ className, item, selectedItem, parentStyles, ...props }) => {

	  return (
			  <div className={cn(
					  className,
					  styles.inventoryItem,
					  {[styles.clicked]: selectedItem === item.id},
					  {[parentStyles.clicked]: selectedItem === item.id},
					  'custom_pointer',
				  )}
			       {...props}
			  >
				  {/*Item*/}
				  <Image className={cn(styles.item_image, parentStyles.image)} src={item.src} alt={item.alt} width={item.width} height={item.height} quality={100}/>

				  {/*Background*/}
				  <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none" className={styles.background}>
					  <path d="M78 8.47826V67.8261H76.3081V71.2174H74.6162V72.913H71.2343V74.6087H69.5425V76.3043H67.8506V78H10.1494V76.3043H8.45754V74.6087H6.76565V72.913H3.38377V71.2174H1.69188V67.8261H0V8.47826H1.69188L1.69565 5.08696H3.3913V3.3913H6.78261V1.69565H10.1739V0H67.8261V1.69565H71.2174V3.3913H74.6087V5.08696H76.3043L76.3081 8.47826H78Z"
					        fill="#A8A78A"/>
				  </svg>

				  {/*Borders*/}
				  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none" className={styles.border_top_left}>
					  <path d="M5.27027 20.2027H0V7.90541H1.58055L1.58407 4.74324H3.16216V3.16216H6.32432V1.58108H9.48649V0H23.3649V5.27027H14.7568V6.85135H11.5946V8.43243H8.43243V10.0135H6.84837L6.84485 13.1757H5.27027V20.2027Z"
					        fill="#6E6E5B"/>
				  </svg>
				  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none" className={styles.border_top_right}>
					  <path d="M5.27027 20.2027H0V7.90541H1.58055L1.58407 4.74324H3.16216V3.16216H6.32432V1.58108H9.48649V0H23.3649V5.27027H14.7568V6.85135H11.5946V8.43243H8.43243V10.0135H6.84837L6.84485 13.1757H5.27027V20.2027Z"
					        fill="#6E6E5B"/>
				  </svg>
				  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none" className={styles.border_bottom_left}>
					  <path d="M5.27027 20.2027H0V7.90541H1.58055L1.58407 4.74324H3.16216V3.16216H6.32432V1.58108H9.48649V0H23.3649V5.27027H14.7568V6.85135H11.5946V8.43243H8.43243V10.0135H6.84837L6.84485 13.1757H5.27027V20.2027Z"
					        fill="#6E6E5B"/>
				  </svg>
				  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none" className={styles.border_bottom_right}>
					  <path d="M5.27027 20.2027H0V7.90541H1.58055L1.58407 4.74324H3.16216V3.16216H6.32432V1.58108H9.48649V0H23.3649V5.27027H14.7568V6.85135H11.5946V8.43243H8.43243V10.0135H6.84837L6.84485 13.1757H5.27027V20.2027Z"
					        fill="#6E6E5B"/>
				  </svg>
			  </div>
	  );
}
export default InventoryItem;